















































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SumupUnitEditTab from "../../components/SumupUnitEditTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { SumupGroup, SumupUnit, CurriculumItem, Curriculum } from "../../modules/teacher/PracticeSumupUnitCourseEdit"

export interface Data {
  tabNo: number
  sumup_group_id: string
  sumup_group: SumupGroup
  sumup_units: SumupUnit[]
  curriculums: Curriculum[]
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
    "sumup-unit-edit-tab": SumupUnitEditTab,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 3,
      sumup_group_id: null,
      sumup_group: null,
      sumup_units: [],
      curriculums: [],
      errors: new Array<string>(),
    });

    /******************************
     * 追加ボタンクリック
     ******************************/

    const addEmptySumupUnit = () => {
      state.sumup_units.push(createEmptySumupUnit());
    }

    /******************************
     * 空の集計レコード追加
     ******************************/

    const createEmptySumupUnit = () => {
      const sumup_unit = new SumupUnit();
      sumup_unit.id = null;
      sumup_unit.name = "";
      sumup_unit.course_code = "";
      sumup_unit.result_published = true;
      sumup_unit.destroy_enable = true;
      state.curriculums.forEach(curriculum => {
        const item = new CurriculumItem();
        item.curriculum_id = curriculum.id;
        item.curriculum_name = curriculum.name;
        item.weight = "1.00";
        item.is_selected = false;
        sumup_unit.curriculum_items.push(item);
      });
      
      return sumup_unit;
    }

    /******************************
     * 集計レコード削除
     ******************************/

    const deleteSumupUnit = (sumup_unit: SumupUnit) => {
      const idx = state.sumup_units.indexOf(sumup_unit);
      state.sumup_units.splice(idx, 1);
    }

    /******************************
     * 保存ボタンクリック
     ******************************/
    
    const saveClick = async () => {

      state.errors = [];

      for(let i = 0; i < state.sumup_units.length; i++){
        const sumup_unit = state.sumup_units[i];
        if(!sumup_unit.name){
          state.errors.push(`${i + 1}行目のコース名が未入力です。`);
        }

        if(!sumup_unit.course_code){
          state.errors.push(`${i + 1}行目のコースCDが未入力です。`);
        }

        if(sumup_unit.curriculum_items.filter(x => x.is_selected).length == 0){
          state.errors.push(`${i + 1}行目の教科が未選択です。`);
        }

        sumup_unit.curriculum_items.forEach(x => {
          if(x.is_selected){
            if(!x.weight){
              state.errors.push(`${i + 1}行目 ${x.curriculum_name}の重みが入力されていません。`);
            }else if(!Common.isFloatOrInteger(x.weight)){
              state.errors.push(`${i + 1}行目 ${x.curriculum_name}の重みに数字以外が入力されています。`);
            }
          }
        });

        if(!sumup_unit.score_bunpu_range){
          state.errors.push(`${i + 1}行目の得点分布単位が入力されていません。`);
        }else if(!Common.isInteger(sumup_unit.score_bunpu_range)){
          state.errors.push(`${i + 1}行目の得点分布単位に整数以外が入力されています。`);
        }

        if(!sumup_unit.sort_no){
          state.errors.push(`${i + 1}行目の表示順が入力されていません。`);
        }else if(!Common.isInteger(sumup_unit.sort_no)){
          state.errors.push(`${i + 1}行目の表示順に整数以外が入力されています。`);
        }
      }

      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("集計情報を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/practice_sumup_unit_course_edit/update/${state.sumup_group_id}`, {sumup_units: state.sumup_units}).then(response => {
        alert("処理が完了しました。")
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      
      await http.get(`/api/teacher/practice_sumup_unit_course_edit/?sumup_group_id=${state.sumup_group_id}`).then(response => {
        
        state.sumup_group = new SumupGroup(response.data.sumup_group);
        state.curriculums = response.data.curriculums.map((x: any) => new Curriculum(x));

        if(response.data.sumup_units.length > 0){
          response.data.sumup_units.forEach((x: any) => {
            const sumup_unit = createEmptySumupUnit();
            sumup_unit.id = x.id;
            sumup_unit.name = x.name;
            sumup_unit.course_code = x.course_code;
            sumup_unit.score_bunpu_range = x.score_bunpu_range;
            sumup_unit.sort_no = `${x.sort_no}`;
            sumup_unit.result_published = x.result_published;
            sumup_unit.destroy_enable = x.destroy_enable;
            
            sumup_unit.curriculum_items.forEach(y => {
              const sumup_unit_curriculum = response.data.sumup_unit_curriculums.filter((z: any) => z.sumup_unit_id == sumup_unit.id && z.curriculum_id == y.curriculum_id)
              if(sumup_unit_curriculum.length > 0){
                y.is_selected = true;
                y.weight = Number(sumup_unit_curriculum[0].weight).toFixed(2);
              }
            });
            state.sumup_units.push(sumup_unit);
          });
        }else{
          // 教科集計未登録の場合、空の入力ボックスを追加
          state.sumup_units.push(createEmptySumupUnit());
        }
        
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。一覧に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      addEmptySumupUnit,
      deleteSumupUnit,
      saveClick
    };
  }
})
